import NavigationBarUp from '../NavigationBarUp';
import { Grid, Stack } from '@mui/material';
import SectionProfileEdit from '../SectionProfileEdit';
import classes from '../../css/PageMain.module.css'

const PageProfileEdit=() =>{
    return(
        <div className={classes.bodyMain}>
            <Stack width='100%' alignItems={'center'}>
                <Grid width='90%' height='100%' container spacing={1}>
                    <Grid height='10%' item xs={12}>
                        <NavigationBarUp></NavigationBarUp>
                    </Grid>
                    <Grid item xs={3}>
                                             
                    </Grid>
                    <Grid item xs={6}>
                        <SectionProfileEdit></SectionProfileEdit>
                    </Grid>
                    <Grid item xs={3}>
                                              
                    </Grid>             
                </Grid>    
            </Stack>          
        </div>      
    );
};

export default PageProfileEdit;